import React, { useState, useRef } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { rtlStyles, ltrStyles, commonStyles } from '../accountAuthorizationStyles';
import IconLock from '../../atoms/Icons/IconLock';
const FormField = _ref => {
  let {
    name,
    placeholder,
    value,
    changeEvent,
    blurEvent,
    type,
    label,
    id,
    labelLight,
    fieldError,
    autoComplete = 'off',
    required = false,
    requiredFromContent = false,
    focusEvent,
    isDisabled = false
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [highLightText, setHighLightText] = useState(false);
  const clickedTextRef = useRef(false);
  function handleChange(event) {
    changeEvent(event.target.value);
  }
  function handleBlur(event) {
    if (blurEvent) blurEvent(event.target.value);
    clickedTextRef.current = false;
    setHighLightText(false);
  }
  function handleTextMousedown() {
    clickedTextRef.current = true;
  }
  function handleFocus(event) {
    if (focusEvent) focusEvent(event.target.value);
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("div", {
    className: `form-group lr__form-group ${isDisabled ? 'field-disabled' : ''}`
  }, /*#__PURE__*/React.createElement("input", {
    className: `
            form-input lr__field input-text-primary
            ${highLightText ? 'input-text-primary--focused' : ''}
            ${value ? 'form-input--filled' : ''}
            ${fieldError && fieldError.length ? 'form-input--error' : ''}
          `,
    name: name,
    placeholder: placeholder,
    type: type,
    value: value,
    id: id,
    onChange: handleChange,
    autoComplete: autoComplete,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMouseDown: handleTextMousedown,
    title: label,
    "aria-label": label,
    disabled: isDisabled
  }), /*#__PURE__*/React.createElement("label", {
    className: `form-label ${labelLight ? 'lr__label-light' : ''}`,
    htmlFor: id
  }, label, required && !requiredFromContent ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "*") : ''), isDisabled ? /*#__PURE__*/React.createElement(IconLock, {
    className: "field-disabled-icon"
  }) : null), ' ', fieldError && fieldError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, fieldError) : null));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${rtl ? rtlStyles : ltrStyles} ${commonStyles} 
    `
  }, children);
};
export default FormField;